import {
  ItemProps,
  SectionProps,
  TableView,
} from '@euler/components/TableView';
import { FontFamily } from '@euler/components/typography';
import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import { FC, memo, useMemo } from 'react';
import { StyleSheet } from 'react-native';
import { useTheme } from 'styled-components';

export const Row: FC<ItemProps> = memo(
  ({ separatorStyle, style, ...props }) => {
    const styles = useStyles();
    return (
      <TableView.Item
        separatorStyle={[styles.separator, separatorStyle]}
        style={[styles.row, style]}
        {...props}
      />
    );
  },
);
Row.displayName = 'TableItem';

export const Section: FC<SectionProps> = memo(
  ({ titleTextStyle, contentStyle, style, ...props }) => {
    const styles = useStyles();
    return (
      <TableView.Section
        titleTextStyle={[styles.sectionTitleText, titleTextStyle]}
        contentStyle={[styles.sectionContent, contentStyle]}
        style={[styles.section, style]}
        {...props}
      />
    );
  },
);
Section.displayName = 'TableSection';

export const useStyles = () => {
  const { rpx } = useResponsiveContext();
  const theme = useTheme();
  return useMemo(
    () =>
      StyleSheet.create({
        row: {
          paddingLeft: rpx(5),
          paddingRight: rpx(5),
          paddingTop: 0,
          paddingBottom: 0,
        },
        separator: {
          marginLeft: rpx(15),
          backgroundColor: '#f2f2f2',
        },
        sectionTitleText: {
          fontFamily: FontFamily.NotoSans.Regular,
          color: theme.inspection.customIssue.labelColor,
          fontSize: rpx(16),
          lineHeight: rpx(18),
          marginBottom: rpx(5),
        },
        sectionContent: {
          backgroundColor: '#fff',
          borderRadius: rpx(8),
          borderWidth: 1,
          borderColor: '#e7e7e7',
          padding: 0,
        },
        section: {
          marginTop: rpx(15),
          marginLeft: rpx(15),
          marginRight: rpx(15),
        },
        formInput: {
          borderWidth: 0,
          backgroundColor: 'transparent',
          paddingLeft: 0,
          paddingRight: 0,
          paddingTop: rpx(8),
          paddingBottom: rpx(8),
          fontSize: rpx(16),
        },
      }),
    [rpx, theme.inspection.customIssue.labelColor],
  );
};
